<template>
  <div
    class="text-[var(--foreground)] dark:bg-[var(--color-1)] dark:bg-[linear-gradient(109.63deg,var(--color-1)_3.67%,var(--color-2)_83.91%)] bg-[#eaeaea] overflow-hidden relative"
  >
    <WrOfficialPartnerHeader />
    <WrHeader />

    <div class="pt-10 mt-32">
      <main id="main-content">
        <slot />
      </main>
    </div>

    <section
      class="grid place-items-center z-10 relative pt-10 max-md:px-4 overflow-hidden"
      id="mask-section"
    >
      <WrAnimatedImg />
    </section>
    <WrFooter />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
const WrAnimatedImg = defineAsyncComponent(
  () => import("~/components/molecules/WrAnimatedImg.vue")
);
const WrFooter = defineAsyncComponent(
  () => import("~/components/molecules/WrFooter.vue")
);
const WrHeader = defineAsyncComponent(
  () => import("~/components/molecules/WrHeader.vue")
);
const WrOfficialPartnerHeader = defineAsyncComponent(
  () => import("~/components/molecules/WrOfficialPartnerHeader.vue")
);
const hydrated = ref(false);
onMounted(() => {
  hydrated.value = true;
});
</script>
